import { SettingsLayout } from '@backstage/plugin-user-settings';
import { UserSettingsGeneral } from '@backstage/plugin-user-settings';
import { IntegrationsTab } from './IntegrationsTab';

export const CustomSettingsPage = () => {
  return (
    <SettingsLayout>
      <SettingsLayout.Route path="general" title="General">
        <UserSettingsGeneral />
      </SettingsLayout.Route>
      <SettingsLayout.Route path="auth-providers" title="Integrations">
        <IntegrationsTab />
      </SettingsLayout.Route>
    </SettingsLayout>
  );
};

